export interface AppRouteAccess {
  basePath: string;
  appId?: string;
  appPrefix?: string;
}

export const APP_ROUTE_ACCESS: AppRouteAccess[] = [
  { basePath: "/map", appId: "lite" },
  { basePath: "/admin", appId: "admin" },
  { basePath: "/reports", appId: "reportes" },
  { basePath: "/envios", appId: "envios-link" },
  { basePath: "/oasis", appId: "oasis" },
  { basePath: "/truck-yard", appId: "truck-yard" },
  { basePath: "/inspecciones", appId: "inspecciones" },
  { basePath: "/flota/integradores", appId: "fleet-integradores" },
  { basePath: "/mantenimiento", appId: "mantenimiento-vehiculos" },
  { basePath: "/finanzas-operativas", appId: "finanzas-operativas" },
  { basePath: "/monitoreo-ia", appId: "monitoreo-ia" },
  { basePath: "/radar-correo", appId: "radar-correo" },
  { basePath: "/passengers", appId: "passenger-management" },
  { basePath: "/pos/cashier", appId: "pos-cashier" },
  { basePath: "/pos/products", appId: "pos-products" },
  { basePath: "/pos/inventory", appId: "pos-inventory" },
  { basePath: "/pos/coupons", appId: "pos-coupons" },
  { basePath: "/pos/orders", appId: "pos-orders" },
  { basePath: "/pos/ecommerce", appId: "pos-ecommerce" },
  { basePath: "/facturacion", appId: "facturacion" },
  { basePath: "/entrega-servicio", appId: "servicios" },
  { basePath: "/support", appId: "support" },
  { basePath: "/reseller-admin", appId: "reseller-admin" },
  { basePath: "/licencias", appId: "licencias" },
  { basePath: "/cobranza", appId: "cobranza" },
  { basePath: "/dashboards", appId: "dashboards" },
  { basePath: "/integradores", appId: "integradores" },
  { basePath: "/respaldos", appId: "respaldos" },
  { basePath: "/service-desk", appId: "service-desk" },
  { basePath: "/bases", appId: "bases" },
  { basePath: "/amenidades", appId: "amenidades" },
  { basePath: "/reservas", appId: "reservas" },
  { basePath: "/rondines", appId: "rondines" },
  { basePath: "/documentacion", appId: "documentacion" },
  { basePath: "/crm", appPrefix: "crm" },
  { basePath: "/nuvex-access", appPrefix: "nuvex-access" },
  { basePath: "/gestion-staff", appPrefix: "gestion-staff" },
  { basePath: "/cargo-market", appPrefix: "cargo-market" },
];

const byBasePath = new Map(
  APP_ROUTE_ACCESS.map((entry) => [entry.basePath, entry]),
);

export function findAppRouteAccess(
  basePath: string,
): AppRouteAccess | undefined {
  return byBasePath.get(basePath);
}
